import React, { useState, useEffect } from 'react';
import { Button, Navbar } from 'react-bootstrap';
import "./external-form.scss";
import { FluentButton } from '../../components/FluentUI/Fluent-Button';
import FluentUiIcon from '../../assets/fluent-ui-icon';
import { CreateTaskFromExternalForm, GetExternalForm } from '../../services/api/task-form-api';
import { useParams } from "react-router-dom";
import { FluentSwitch } from "../../components/FluentUI/Fluent-Switch";
import { FluentInput } from "../../components/FluentUI/Fluent-Input";
import { FluentInputArea } from "../../components/FluentUI/Fluent-InputArea";
import { FluentDropdown } from "../../components/FluentUI/Fluent-Dropdown";
import { FluentDatePicker } from "../../components/FluentUI/Fluent-DatePicker";
import { BaseFormField, FieldTypes } from '../tasks/scenes/task-form/task-form-util';
import CustomFileDropZone from '../../components/DynamicField/CustomFileDropZone/CustomFileDropZone';
import { FileField } from '../../components/FluentUI/FileField';
import { getFormattedDate } from '../../util/time-helpers';

const ExternalForm = (props) => {

    let params = useParams();
    const [formFields, setFormFields] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [isCreated, setIsCreated] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const GetExternalFormInit = async (guid) => {
        let result = await GetExternalForm(guid);
        if (result?.status === 200) {
            setFormFields(result?.data.Fields);
        }
    };

    useEffect(() => {
        GetExternalFormInit(params.formId);
    }, []);

    function createDynamicInputChangeHandler({ field }) {
        return function (event, data) {
            if (field.FieldType == FieldTypes.file) {
                setFormFields((oldDynamicFields) =>
                    oldDynamicFields.map((oldField) =>
                        oldField.Id === field.Id
                            ? {
                                ...oldField,
                                Files:event,
                                touched: true,
                            }
                            : oldField
                    )
                );
            }
            else {
                if (field.FieldType !== "Date" && !(field.IsBaseField && (field.DynamicFieldId == BaseFormField.StartDate || field.DynamicFieldId == BaseFormField.EndDate))) {
                    let Data;
                    if (field.FieldType == "Dropdown") {
                        Data = data.optionValue
                    }
                    else {
                        Data = event.target.value;
                    }
                    setFormFields((oldDynamicFields) =>
                        oldDynamicFields.map((oldField) =>
                            oldField.Id === field.Id
                                ? {
                                    ...oldField,
                                    Data,
                                    touched: true,
                                }
                                : oldField
                        )
                    );

                }
                else {
                    if (event) {
                        const Data = event;
                        setFormFields((oldDynamicFields) =>
                            oldDynamicFields.map((oldField) =>
                                oldField.Id === field.Id
                                    ? {
                                        ...oldField,
                                        Data,
                                        touched: true,
                                    }
                                    : oldField
                            )
                        );
                    }
                }
            }
        };
    }

    const CreateTask = async () => {
        setSubmitting(true);
        setIsButtonDisabled(true);
        
        const hasValidationErrors = formFields.some(x => x.IsRequired && (!x.Data || String(x.Data).trim() === ""));
        if (hasValidationErrors) {
            setIsButtonDisabled(false);
            return;
        }

        let obj = {
            Id: params.formId,
            Fields: formFields
        }
        let result = await CreateTaskFromExternalForm(obj);
        if (result?.status === 200) {
            setIsCreated(true);
        }
        else {
            console.log(result);
            setIsButtonDisabled(false);
        }

    }

    const ResetFormSection = () => {
        window.location.reload();
    }

    const LoadFormField = (field, values) => {
        if (formFields.length > 0) {
            let fieldComponent;
            let fieldComponentProps = {
                id: `field-${field.Id}`,
                label: field.LocalLabel ? field.LocalLabel : field.DefaultLabel,
                required: field.IsRequired,
                defaultValue: field.DefaultValue,
                disabled: field.IsDisabled,
                validationMessage: submitting && field.IsRequired && (!field.Data || String(field.Data).trim() === "") ? "This field is required" : "",
                defaultFiles: field?.Files ?? [],
            };
            if (field.IsBaseField) {
                switch (field.DynamicFieldId) {
                    case BaseFormField.TaskName:
                        fieldComponent = FluentInput;
                        break;
                    case BaseFormField.Project:
                        fieldComponent = FluentInput;
                        break;
                    case BaseFormField.StartDate:
                        fieldComponent = FluentDatePicker;
                        fieldComponentProps.value =  new Date();
                        field.Data = getFormattedDate(new Date());
                        createDynamicInputChangeHandler({field});
                        break;
                    case BaseFormField.EndDate:
                        fieldComponent = FluentDatePicker;
                        fieldComponentProps.value = field.Data;
                        break;
                    case BaseFormField.Priority:
                        fieldComponent = FluentDropdown;
                        fieldComponentProps.options = field.LookUpValues.split("|");
                        break;
                    case BaseFormField.TaskType:
                        fieldComponent = FluentDropdown;
                        fieldComponentProps.options = field.LookUpValues.split("|");
                        break;
                    default:
                        fieldComponent = FluentInput;
                        break;
                }

            }
            else {
                switch (field.FieldType) {
                    case FieldTypes.ShortTextEntry:
                        fieldComponent = FluentInput;
                        break;
                    case FieldTypes.LongTextEntry:
                        fieldComponent = FluentInputArea;
                        break;
                    case FieldTypes.Dropdown:
                        fieldComponent = FluentDropdown;
                        fieldComponentProps.options = field.LookUpValues.split("|");
                        break;
                    case FieldTypes.Date:
                        fieldComponent = FluentDatePicker;
                        fieldComponentProps.value = field.Data;
                        break;
                    case FieldTypes.Toggle:
                        fieldComponentProps.checked = field.Data === "selected";
                        fieldComponent = FluentSwitch;
                        break;
                    case FieldTypes.NumericDecimal:
                    case FieldTypes.NumericInteger:
                        fieldComponentProps.type = "number";
                        fieldComponent = FluentInput;
                        break;
                    case FieldTypes.file:
                        fieldComponent = FileField;
                        break;
                    default:
                        fieldComponent = FluentInput;
                        break;
                }
            }
            return React.createElement(fieldComponent, fieldComponentProps);
        }
    };

    return (
        !isCreated ? <div className="external-form-container">
            <Navbar className="top-nav nav-bar nav-bar-container">
                <div className="flex-container">
                    <Navbar.Brand href="/">
                        <div className="logo"></div>
                    </Navbar.Brand>
                </div>
            </Navbar>
            <div className="external-form-body">
                <div className='external-form-body-header'>
                    <span >
                        Create a new Task
                    </span>
                    <FluentButton
                        icon={
                            <FluentUiIcon
                                name={"EraserRegular"}
                                color={"#0F6CBD"}
                                size={20}
                            />
                        }
                        text={"Reset Form"}
                        onClick={() => {
                            ResetFormSection();
                        }}
                    />
                </div>
                <div className='external-form-body-fields'>
                    {formFields?.filter(x => !x.IsHidden).map((field) => {
                        const formField = LoadFormField(field, []);
                        return (
                            <div
                                className="form-field d-flex flex-column align-items-start"
                                key={field.Id}
                                data-testid={`form-field-${field.Id}`}
                            >
                                {React.cloneElement(formField, {
                                        onChange: createDynamicInputChangeHandler({field})
                                    }) 
                                }
                            </div>
                        );
                    }
                    )}
                </div>
                <div className='external-form-submit'><Button onClick={CreateTask} disabled={isButtonDisabled}>Submit</Button></div>
            </div>
        </div>
            : <div className='external-form-container'>
                <div className='external-form-creation-body'>
                    <div className='external-from-creation-border'>
                        <div className="logo"></div>
                        <div className='external-form-creation-title'>
                            A new Task was created!
                        </div>
                        <div className='creation-text'>
                            A new Task was successfully created on TRIYO with the submitted data.
                        </div>
                        <div className='creation-text'>
                            Click the button below to create another Task.
                        </div>
                        <Button className='m-4' onClick={ResetFormSection}>Submit Another Response</Button>
                    </div>
                </div>
            </div>

    );
}

export default ExternalForm;
